var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',{attrs:{"title":_vm.title}},[(_vm.multipage)?_c('keep-alive',[_c('router-view',{ref:"page"})],1):_c('router-view',{ref:"page"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }